import z from 'zod'
import {
  nullSafeOptionalFirestoreTimestamp,
  nullSafeOptionalString,
} from '../shared/schema'

export const schema = z.object({
  installNotes: nullSafeOptionalString(),
  previousPromptVersionId: nullSafeOptionalString(),
  promptVersionId: z.string(),
  updatedAt: nullSafeOptionalFirestoreTimestamp(),
  userId: nullSafeOptionalString(),
})

export const empty = Object.freeze(
  schema.parse({
    promptVersionId: '',
  })
)

export type FirestoreCurrentPromptVersion = z.infer<typeof schema>
